import {
  publicHttpClient,
  type DefaultQueryError,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { apiRoutes } from './api-routes';
import { publicEnv } from '@/config/public-env.config.mjs';

export interface GetSuggestQuestionsResponse {
  suggest_question: string[];
}

export interface GetSuggestQuestionsParams {
  customer_id: string;
  city_id: string;
  store_id?: number;
}

export const getSuggestQuestionsFn = async (
  params: GetSuggestQuestionsParams | undefined
): Promise<GetSuggestQuestionsResponse> => {
  const url =
    publicEnv.NEXT_PUBLIC_APP_FOOD_API_URI +
    apiRoutes.ahafood.store.chatbot_suggest_questions;
  const response = await publicHttpClient.get<GetSuggestQuestionsResponse>(
    url,
    {
      params,
    }
  );
  return response?.data;
};

export const useGetSuggestQuestions = (
  params?: GetSuggestQuestionsParams,
  opts?: Omit<
    UseQueryOptions<
      GetSuggestQuestionsResponse,
      DefaultQueryError,
      GetSuggestQuestionsResponse,
      [string, GetSuggestQuestionsParams | undefined]
    >,
    'queryKey' | 'queryFn'
  >
) =>
  useQuery<
    GetSuggestQuestionsResponse,
    DefaultQueryError,
    GetSuggestQuestionsResponse,
    [string, GetSuggestQuestionsParams | undefined]
  >({
    queryKey: [apiRoutes.ahafood.store.chatbot_suggest_questions, params],
    queryFn: () => getSuggestQuestionsFn(params),
    enabled: Boolean(params?.customer_id && params?.city_id),
    ...opts,
  });
